import { ArrowRightIcon } from "@heroicons/react/solid";
import React from "react";

export const BetterDataSection = () => {
  return (
    <div className="container-lg grid-12 pt-[108px] pb-80">
      <div className="col-span-full md:col-span-5 md:col-start-2">
        <div>
          <h3 className="items-center font-display text-24-32 md:text-32-40">
            Better data{" "}
            <ArrowRightIcon className="ml-4 mr-8 mb-4 inline-block h-24 w-24 flex-none" />
            Better models
          </h3>
          <div className="mt-40 flex flex-col gap-20 md:max-w-[336px]">
            <p className="text-16-24 md:text-18-28 ">
              A big weakly supervised dataset can be better than a small
              labelled dataset. Humanloop Programmatic dramatically increases
              the size of your datasets.
            </p>
            <p className="text-16-24 text-gray-700">
              Benefit from both your unlabelled and manually annotated data. The
              combination of programmatic labels with manual labels leads to a
              better model.
            </p>
          </div>
        </div>
      </div>
      <div className="col-span-full mx-auto max-w-[480px] px-20 pt-40 md:col-span-6 md:pt-0 md:pl-40 md:pr-32">
        <img
          src="/assets/marketing/Dataset Stacks.png"
          className=""
          alt="More data, better models"
        />
      </div>
    </div>
  );
};
